import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { List, Map } from 'immutable';
import { max as d3max, sum as d3sum } from 'd3-array';
import { formatDecimal2FractionDigits } from '@instructure/quiz-i18n';
import ReduxRecord from './reduxRecord';
import { interactionTypeMetadata } from '../util/interactionTypeMetadata';
export var ItemAnalysis = /*#__PURE__*/function (_ReduxRecord) {
  function ItemAnalysis() {
    _classCallCheck(this, ItemAnalysis);
    return _callSuper(this, ItemAnalysis, arguments);
  }
  _inherits(ItemAnalysis, _ReduxRecord);
  return _createClass(ItemAnalysis, [{
    key: "isLoaded",
    value: function isLoaded() {
      return this.itemId !== '0';
    }
  }, {
    key: "interactionTypeName",
    value: function interactionTypeName() {
      var intData = interactionTypeMetadata({
        slug: this.interactionType
      });
      return intData.name;
    }
  }, {
    key: "correctAnswerInfo",
    value: function correctAnswerInfo() {
      return this.itemAnalysis.get('correctAnswerInfo', Map());
    }
  }, {
    key: "incorrectAnswerInfo",
    value: function incorrectAnswerInfo() {
      return this.itemAnalysis.get('incorrectAnswerInfo', Map());
    }
  }, {
    key: "isPresent",
    value: function isPresent() {
      return !this.notFound;
    }
  }, {
    key: "scoreInfo",
    value: function scoreInfo() {
      return this.itemAnalysis.get('scoreInfo', Map());
    }
  }, {
    key: "choiceInfo",
    value: function choiceInfo() {
      return this.itemAnalysis.get('choiceInfo', List());
    }
  }, {
    key: "topCorrectAnswerInfo",
    value: function topCorrectAnswerInfo() {
      return this.itemAnalysis.get('topCorrectAnswerInfo', Map());
    }
  }, {
    key: "bottomCorrectAnswerInfo",
    value: function bottomCorrectAnswerInfo() {
      return this.itemAnalysis.get('bottomCorrectAnswerInfo', Map());
    }
  }, {
    key: "unansweredInfo",
    value: function unansweredInfo() {
      return this.itemAnalysis.get('unansweredInfo', 0);
    }
  }, {
    key: "quintile",
    value: function quintile() {
      return this.itemAnalysis.get('quintile', List([0, 0, 0, 0, 0])).toJS();
    }
  }, {
    key: "choiceCounts",
    value: function choiceCounts() {
      return this.choiceInfo().toJS().map(function (c) {
        return c.choiceCount;
      }).concat(this.unansweredInfo());
    }
  }, {
    key: "choiceCountMax",
    value: function choiceCountMax() {
      return d3max(this.choiceCounts());
    }
  }, {
    key: "choiceCountSum",
    value: function choiceCountSum() {
      return d3sum(this.choiceCounts());
    }
  }, {
    key: "calculateMeanScore",
    value: function calculateMeanScore(scoreInfo) {
      var sum = scoreInfo.get('resultSum') || 0;
      var count = scoreInfo.get('resultCount') || 0;
      return sum / count;
    }
  }, {
    key: "calculateDifficultyRatio",
    value: function calculateDifficultyRatio(correctAnswerInfo) {
      var correctAnswerCount = correctAnswerInfo.get('resultCount') || 0;
      var appearedCount = correctAnswerInfo.get('appearedCount') || 0;
      return correctAnswerCount / appearedCount;
    }
  }, {
    key: "formatDecimal",
    value: function formatDecimal(value, locale) {
      return isFinite(value) ? formatDecimal2FractionDigits(value, locale) : null;
    }
  }, {
    key: "meanScore",
    value: function meanScore(locale) {
      return this.formatDecimal(this.calculateMeanScore(this.scoreInfo()), locale);
    }
  }, {
    key: "difficultyIndex",
    value: function difficultyIndex(locale) {
      return this.formatDecimal(this.calculateDifficultyRatio(this.correctAnswerInfo()), locale);
    }
  }, {
    key: "pointBiserial",
    value: function pointBiserial(locale) {
      var correctMean = this.calculateMeanScore(this.correctAnswerInfo());
      var incorrectMean = this.calculateMeanScore(this.incorrectAnswerInfo());
      var stdDeviation = this.scoreInfo().get('scoreStddevPop');
      var numCorrect = this.correctAnswerInfo().get('resultCount');
      var numInCorrect = this.incorrectAnswerInfo().get('resultCount');
      var totalTakers = this.correctAnswerInfo().get('appearedCount');
      var firstTerm = (correctMean - incorrectMean) / stdDeviation;
      var secondTerm = Math.sqrt(numCorrect * numInCorrect / (totalTakers * totalTakers));
      return this.formatDecimal(firstTerm * secondTerm, locale);
    }
  }, {
    key: "discriminationIndex",
    value: function discriminationIndex(locale) {
      var topDifficulty = this.calculateDifficultyRatio(this.topCorrectAnswerInfo());
      var bottomDifficulty = this.calculateDifficultyRatio(this.bottomCorrectAnswerInfo());
      return this.formatDecimal(topDifficulty - bottomDifficulty, locale);
    }
  }]);
}(ReduxRecord({
  itemId: '0',
  quizId: '0',
  pointsPossible: '0',
  interactionType: null,
  itemBody: null,
  itemAnalysis: null,
  notFound: false,
  outcomeAlignmentSetGuid: null
}));
export default ItemAnalysis;